import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { ContenidoConvenios } from 'src/app/models/complementos-web/complementos-web.model';
import { NgClass } from '@angular/common';
import { OcultaPaginadorPaginadorDirective } from '../../@directives/ocultar-elemento-paginador.directive';

@Component({
    selector: 'app-lista-polizas-agentes-convenios',
    templateUrl: './lista-polizas-agentes-convenios.component.html',
    styleUrls: ['./lista-polizas-agentes-convenios.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, NgClass, MatFooterRowDef, MatFooterRow, MatPaginator, OcultaPaginadorPaginadorDirective]
})
export class ListaPolizasAgentesConveniosComponent implements AfterViewInit {

  @ViewChild('convenio') paginator: MatPaginator;
  @ViewChild('agentes') paginator2: MatPaginator;

  @Input() public set datosConvenio(datos) {
    this.tablaConvenios = new MatTableDataSource<ContenidoConvenios>(datos ?? []);
    setTimeout(() => {
      this.tablaConvenios.paginator = this.paginator;
    }, 100);
  };
  @Input() public set datosAgentes(datos) {
    this.tablaAgentes = new MatTableDataSource<ContenidoConvenios>(datos ?? []);
      setTimeout(() => {
      this.tablaAgentes.paginator = this.paginator2;
    }, 100);
  };
  @Input() public agenteNombre: string;
  @Input() public esRegistroPar: boolean;

  public muestraGrid: boolean = false;

  public tablaConvenios : MatTableDataSource<ContenidoConvenios>;
  public tablaAgentes: MatTableDataSource<ContenidoConvenios>;

  // Tabla Secciones
  public tamanoResultados: number = 0;
  public selectPolizaDatos = null;
  public selectAgenteDatos = null;
  public selectedPolizaRowIndex: number = null;
  public selectedAgenteRowIndex: number = null;

  public displayColumns = ['Alta', 'Inicio', 'Autoriza', 'Termino', 'Estatus'];

  constructor() {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.tablaConvenios.paginator = this.paginator;
      this.tablaAgentes.paginator = this.paginator2;
    }, 100);
  }

  SelectRow(row, tipo: 'POLIZA' | 'AGENTE') {
    if (tipo === 'POLIZA') {
      this.selectedPolizaRowIndex = row.consecutivo;
      this.selectPolizaDatos = row;
    }
    if (tipo === 'AGENTE') {
      this.selectedAgenteRowIndex = row.consecutivo;
      this.selectAgenteDatos = row;
    }
  }
}
